import React, { Component } from 'react';
import LoadingComponent from '../commonComponents/LoadingComponent';
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css'; 
// this component is used when Dropdown have to be used in a Parent Component,independent of forms
class MergeDropdownComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedData: null,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleTitle = this.handleTitle.bind(this);
        this.handleDropdownConfig = this.handleDropdownConfig.bind(this);
        this.handleKeyCheck = this.handleKeyCheck.bind(this);
    }

    componentWillMount() {
        // jQuery('.selectpicker').selectpicker('render');
        if (this.state.selectedData == null && (this.props.dropdownConfig.async !== undefined && this.props.dropdownConfig.async == true)) {
            let that = this;
            this.props.asyncHandle(this.props.asyncParams, function (response) {
                that.setState({
                    selectedData: response
                })
            });
        }
        else {
            jQuery('.selectpicker').selectpicker('refresh');
        }

    }

    componentDidUpdate(prevProps, nextState) {
        // if (prevProps.detectChangeParam !== this.props.detectChangeParam){
        // jQuery('.selectpicker').selectpicker('render');
        jQuery('.selectpicker').selectpicker('refresh');
        this.initializeChoices();
    }

    componentDidMount() {
        // jQuery('.selectpicker').selectpicker('refresh');
        this.initializeChoices();
        
    }
    initializeChoices() {
        const dropdown = document.querySelectorAll('.js-choice');
        dropdown.forEach((selectElement) => {
            new Choices(selectElement, {
                searchEnabled: true,
                shouldSort: false,
                maxItemCount: 10,
                placeholderValue: 'Select table option',
                placeholder: true,
                removeItemButton: true,
                delimiter: ",",
                classNames: {
                    containerInner: 'custom-class-for-container',
                    listDropdown: 'custom-class-for-dropdown'
                }
            });
        });
    }

    handleChange(e) {

        this.props.onChange(e, this);
    }

    handleTitle() {

        this.props.columnTitle(e, this);
    }

    handleDropdownConfig(configObj) {
        let configKeys = ['data', 'async', 'class', 'multi', 'label', 'optionValue', 'size', 'search', 'placeholder','subtext','width'];
        for (var key of configKeys) {
            let check = this.handleKeyCheck(key, configObj);
            switch (key) {
                case 'async':
                    if (!check) {
                        configObj[key] = false;
                    }
                    break;
                case 'multi':
                    if (check) {
                        configObj[key] = check ? true : null;
                    }
                    break;
                case 'label':
                    configObj[key] = check ? configObj[key] : 'name';
                    break;
                case 'optionValue':
                    configObj[key] = check ? configObj[key] : 'value';
                    break;
                case 'size':
                    configObj[key] = check ? configObj[key] : 10;
                    break;
                case 'class':
                    configObj[key] = check ? configObj[key] : 'col-md-12';
                    break;
                case 'placeholder':
                    configObj[key] = check ? configObj[key] : null;
                    break;
                case 'subtext':
                    configObj[key] = check ? configObj[key] : null;
                    break;
                case 'width':
                    configObj[key] = check ? configObj[key] : null;
                    break;
                default:
                    break;
            }
        }
        return configObj;
    }

    handleKeyCheck(key, obj) {
        return (obj[key] !== null && obj[key] !== undefined) ? true : false
    }




    render() {
        let that = this;
        var optionContent = null;

        var finalConfig = this.handleDropdownConfig(this.props.dropdownConfig);
        var selectDropdownComponent = <LoadingComponent />;
        var data = finalConfig.data;
        if (finalConfig == true) {
            data = this.state.selectedData;
        }
        else {
            data = finalConfig.dropdownData;
        }

        if (data !== null && data !== undefined) {
            if (this.props.dropdownConfig.externalOptions !== undefined && this.props.dropdownConfig.externalOptions){
                optionContent = this.props.dropdownConfig.optionContent;
            }
            else{
            optionContent = data.map((element, i) => {
                let innerKeyValue = element[finalConfig['optionValue']];
                let innerOptionValue = finalConfig['optionValue'];
                    let subtext = finalConfig['subtext'] ? element['subtext_value'] : null;
                    return (<option data-subtext={subtext} key={`${innerKeyValue}_${i}`} value={element[innerOptionValue]}>{element[finalConfig['label']]}</option>);
                });
            }
            let dropDownValue = that.props.dropdownConfig.value ? that.props.dropdownConfig.value: "";

            if(!this.props.dropdownConfig.valueFlag){
                selectDropdownComponent = (
                    <select data-dropup-auto="false" multiple={finalConfig['multi']} async={finalConfig['async']} name={finalConfig['name']} data-width={finalConfig['width']} data-live-search={true} data-show-subtext={finalConfig['subtext']} data-size={finalConfig['size']} id={finalConfig['id']} onChange={this.handleChange} title={finalConfig['placeholder']} className={`js-choice form-control ${finalConfig['class']}`} defaultValue={dropDownValue} data-style="btn btn-sm btn-white" data-selected-text-format="count">
                        {optionContent}
                    </select>
                );
            }
            else{
                selectDropdownComponent = (
                    <select data-dropup-auto="false" multiple={finalConfig['multi']} async={finalConfig['async']} name={finalConfig['name']} data-width={finalConfig['width']}  data-show-subtext={finalConfig['subtext']} data-bs-size={finalConfig['size']} id={finalConfig['id']} onChange={this.handleChange} title={finalConfig['placeholder']} className={`js-choice form-control ${finalConfig['class']}`} value={dropDownValue} data-bs-style="btn btn-sm btn-white" data-selected-text-format="count" >
                        {optionContent}
                    </select>
                );
            }
          
        }

        return (
            // <div>
            //     {selectDropdownComponent}
            // </div>
            <div key={`row_${"i"}`} className="mb-2 " style={{ width: "max-content", minWidth:"190px" }}>
                <div key={`col_${"i"}`} className="">
                    {selectDropdownComponent}
                </div>
            </div>
        )
    }
}

export default MergeDropdownComponent;